
import { Vue, Options } from 'vue-class-component'
import { Chart } from 'chart.js'

@Options({
  props: {
    payment_statistic: Object
  },
  name: 'DoughnutChart',
  watch: {
    payment_statistic: {
      handler: 'loadDatas',
      deep: true
    }
  },
  data () {
    return {
      colorList: ['#379AE6', '#FF6384', '#36EBBE', '#FFCE56', '#C3E1F8'],
      doughnutchart: null,
      doughnutChartConfig: {
        type: 'doughnut',
        responsive: true,
        data: {
          labels: [],
          datasets: [
            {
              label: 'My First Dataset',
              data: [],
              backgroundColor: [],
              hoverOffset: 4
            }
          ]
        },
        options: {
          legend: {
            position: 'right'
          },
          tooltips: {
            enabled: false,
            custom: function (tooltipModel) {
              // if (!tooltipModel) return;
              const data = this._data.datasets[0].data.map((x) => x)
              const bill_type = this._data.labels.map((x) => x)
              const colorlist = this._data.datasets[0].backgroundColor.map(
                (x) => x
              )
              const totaldata = data.reduce((a, b) => a + b, 0)

              // Tooltip Element
              let tooltipEl = document.getElementById('chartjs-tooltip')

              // Create element on first render
              if (!tooltipEl) {
                tooltipEl = document.createElement('div')
                tooltipEl.id = 'chartjs-tooltip'
                tooltipEl.innerHTML = '<table></table>'
                document.body.appendChild(tooltipEl)
              }

              // Hide if no tooltip
              if (tooltipModel.opacity === 0) {
                tooltipEl.style.opacity = '0'
                return
              }

              // Set caret Position
              tooltipEl.classList.remove('above', 'below', 'no-transform')
              if (tooltipModel.yAlign) {
                tooltipEl.classList.add(tooltipModel.yAlign)
              } else {
                tooltipEl.classList.add('no-transform')
              }

              function getBody (bodyItem) {
                return bodyItem.lines
              }

              // Set Text
              if (tooltipModel.body) {
                const bodyLines = []

                for (var i = 0; i < data.length; i++) {
                  const bodyLine = [
                    `${bill_type[i]}:${data[i]}`
                  ]
                  bodyLines.push(bodyLine)
                }

                let innerHtml = '<thead>'

                innerHtml += "<tr><th colspan='4'>Tagihan Terbayar</th></tr>"
                innerHtml += '</thead><tbody>'

                bodyLines.forEach(function (body, i) {
                  const colors = colorlist[i]
                  let style = 'background:' + colors
                  style += '; border-color:' + colors
                  style += '; border-width: 2px'
                  style += '; height: 15px'
                  style += '; width: 15px'
                  style += '; border-radius: 50%'
                  const div = '<div style="' + style + '">&nbsp;</div>'
                  // split body
                  const title = body[0].split(':')[0].trim()
                  let value = body[0].split(':')[1].trim()
                  const percent = ((value / totaldata) * 100).toFixed(2)
                  value = 'Rp. ' + parseInt(value).toLocaleString()
                  innerHtml += '<tr><td>' + div + '</td><td>' + title + '</td><td>' + value + '</td><td>' + percent + '%</td></tr>'
                })

                innerHtml += "<tr style='background: #1E232E;'><td><div style='background: #fff; border-color: #fff; border-width: 2px; height: 15px; width: 15px;'>&nbsp;</div></td><td>Total</td><td>Rp. " + parseInt(totaldata).toLocaleString() + '</td><td>100%</td></tr>'

                innerHtml += '</tbody>'

                const tableRoot = tooltipEl.querySelector('table')
                if (tableRoot) {
                  tableRoot.innerHTML = innerHtml
                  tableRoot.style.borderCollapse = 'collapse'
                  tableRoot.style.border = 'none'
                  const td = tableRoot.querySelectorAll('td')
                  for (var i = 0; i < td.length; i++) {
                    td[i].style.padding = '5px'
                    td[i].style.whiteSpace = 'nowrap'
                  }

                  const th = tableRoot.querySelectorAll('th')
                  for (var i = 0; i < th.length; i++) {
                    th[i].style.padding = '5px'
                    th[i].style.whiteSpace = 'nowrap'
                  }
                }
              }

              // `this` will be the overall tooltip
              const position = this._chart.canvas.getBoundingClientRect()

              // Display, position, and set styles for font
              tooltipEl.style.opacity = '1'
              tooltipEl.style.position = 'absolute'
              tooltipEl.style.background = '#2E353B'
              tooltipEl.style.color = 'white'
              tooltipEl.style.border = '1px solid #1b1f23'
              tooltipEl.style.borderRadius = '3px'
              tooltipEl.style.left = position.left - 100 + window.pageXOffset + tooltipModel.caretX + 'px'
              tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px'
              tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily
              tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px'
              tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle
              tooltipEl.style.padding =
                tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px'
              tooltipEl.style.pointerEvents = 'none'
            }
          }
        }
      }
    }
  },
  methods: {
    loadDatas: async function () {
      const data = this.payment_statistic
      if (data.bill_type.length > 0) {
        // loop through data

        this.doughnutChartConfig.data.labels = []
        this.doughnutChartConfig.data.datasets[0].data = []
        this.doughnutChartConfig.data.datasets[0].backgroundColor = []

        for (let i = 0; i < data.bill_type.length; i++) {
          this.doughnutChartConfig.data.labels.push(data.bill_type[i].name)
          this.doughnutChartConfig.data.datasets[0].data.push(
            data.bill_type[i].total
          )
          this.doughnutChartConfig.data.datasets[0].backgroundColor.push(
            this.colorList[i % 5]
          )
        }
      } else {
        this.doughnutChartConfig.data.labels = []
        this.doughnutChartConfig.data.datasets[0].data = []
        this.doughnutChartConfig.data.datasets[0].backgroundColor = []
      }

      const ctx = document.getElementById('doughnutchart') as HTMLCanvasElement

      // check if chart already initialized
      if (this.doughnutchart !== null) {
        this.doughnutchart.update()
      } else {
        this.doughnutchart = new Chart(ctx, this.doughnutChartConfig)
      }
    }
  },
  mounted () {
    this.loadDatas()
  }
})
export default class DoughnutChart extends Vue {}
